"use strict";
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserColor = exports.isSoftBackground = exports.SoftBackgrounds = void 0;
exports.SoftBackgrounds = {
    skyblue: 'var(--iui-color-background-skyblue)',
    celery: 'var(--iui-color-background-celery)',
    froly: 'var(--iui-color-background-froly)',
    steelblue: 'var(--iui-color-background-steelblue)',
    sunglow: 'var(--iui-color-background-sunglow)',
    seabuckthorn: 'var(--iui-color-background-seabuckthorn)',
    montecarlo: 'var(--iui-color-background-montecarlo)',
    poloblue: 'var(--iui-color-background-poloblue)',
    bouquet: 'var(--iui-color-background-bouquet)',
    ash: 'var(--iui-color-background-ash)',
    oak: 'var(--iui-color-background-oak)',
};
/** Returns true if a string value is one of the SoftBackgrounds keys */
const isSoftBackground = (value) => {
    return Object.keys(exports.SoftBackgrounds).includes(value);
};
exports.isSoftBackground = isSoftBackground;
const USER_COLORS = [
    '#6AB9EC',
    '#B1C854',
    '#F7706C',
    '#4585A5',
    '#FFC335',
    '#F7963E',
    '#73C7C1',
    '#85A9CF',
    '#A3779F',
    '#C8C2B4',
    '#A47854',
];
/**
 * Generate color from user name or email.
 * Recommended to use for `backgroundColor` in `Avatar` component.
 */
const getUserColor = (emailOrName) => {
    const normalizedString = emailOrName.trim().toLowerCase();
    let hash = 0;
    for (let i = 0; i < normalizedString.length; i++) {
        const charCode = normalizedString.charCodeAt(i);
        hash = (hash + charCode) % USER_COLORS.length;
    }
    return USER_COLORS[hash];
};
exports.getUserColor = getUserColor;
